module.exports = __webpack_public_path__ + "img/loginLogoQd.cc9a03d8.png";